import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface Props {
  children: ReactNode; //
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { loggedIn } = useAuth();
  if (!loggedIn) return <Navigate to="/" replace />;
  return <>{children}</>; // 用 Fragment 包裹
};

export default ProtectedRoute;
